export const ALLOWED_FILE_TYPES: {
  mimeType: string
  extension: string
}[] = [
  // Documents
  { mimeType: 'application/pdf', extension: 'pdf' },
  { mimeType: 'application/msword', extension: 'doc' },
  { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', extension: 'docx' },
  { mimeType: 'text/plain', extension: 'txt' },
  { mimeType: 'application/rtf', extension: 'rtf' },
  { mimeType: 'application/vnd.oasis.opendocument.text', extension: 'odt' },
  { mimeType: 'application/x-iwork-pages-sffpages', extension: 'pages' },
  // Spreadsheets
  { mimeType: 'application/vnd.ms-excel', extension: 'xls' },
  { mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: 'xlsx' },
  { mimeType: 'text/csv', extension: 'csv' },
  { mimeType: 'application/vnd.oasis.opendocument.spreadsheet', extension: 'ods' },
  { mimeType: 'application/x-iwork-numbers-sffnumbers', extension: 'numbers' },
  // Presentations
  { mimeType: 'application/vnd.ms-powerpoint', extension: 'ppt' },
  { mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', extension: 'pptx' },
  { mimeType: 'application/vnd.oasis.opendocument.presentation', extension: 'odp' },
  { mimeType: 'application/x-iwork-keynote-sffkey', extension: 'key' },
  // Images
  { mimeType: 'image/jpeg', extension: 'jpg' },
  { mimeType: 'image/jpeg', extension: 'jpeg' },
  { mimeType: 'image/png', extension: 'png' },
  { mimeType: 'image/gif', extension: 'gif' },
  { mimeType: 'image/bmp', extension: 'bmp' },
  { mimeType: 'image/svg+xml', extension: 'svg' },
  { mimeType: 'image/webp', extension: 'webp' },
  { mimeType: 'image/tiff', extension: 'tiff' },
  { mimeType: 'image/tiff', extension: 'tif' },
  // Other common formats
  { mimeType: 'application/json', extension: 'json' },
  { mimeType: 'application/xml', extension: 'xml' },
  { mimeType: 'text/plain', extension: 'log' },
]
